<ng-template #template>
  <ng-container *ngIf="isDisplayed">
    <div class="l-mybooking__option-item">
      <asw-next-action-item
        (clickNextAction)="onClick()"
        [canBeClicked]="canBeClicked"
        [title]="'label.alternativeFlightIndex' | staticMsg"
        [titleAria]="'reader.alternativeFlight' | staticMsg"
        [textContent]="'label.alternativeFlightText' | staticMsg"
        itemId="adknowledge"
      >
      </asw-next-action-item>
    </div>
  </ng-container>
</ng-template>
